// How to export trades from each platform: the homepage (#export) and the free report card.
export const EXPORTS = [
  {
    name: 'TopstepX',
    steps: ['Open the Trades tab at the bottom of the screen. Trades includes your fees; Orders works too, but without fees.', 'Click Export and pick a date range.', 'Click Export again. The file downloads to your computer.'],
  },
  {
    name: 'Tradovate',
    steps: ['Click the gear icon next to your account name and open Account Reports.', 'Go to the Orders tab (not Performance), pick your dates and click Go.', 'Click Download to save the CSV.'],
  },
  {
    name: 'NinjaTrader (web)',
    steps: ['NinjaTrader on the web runs on Tradovate, so the file is the same: open Account Reports from your account menu.', 'Go to the Orders tab, pick your dates and download the CSV.', 'The file has no fees, so type your per-side rate when you import. You can find it in Cash History.'],
  },
  {
    name: 'Tradesea',
    steps: ['Open your Orders history in Tradesea and pick the dates.', 'Export it as a CSV. The file has your fills and commissions, so fees come in on their own.'],
  },
  {
    name: 'Any other platform',
    steps: ['Export your trade history as a CSV.', 'It needs a symbol, an entry price and an exit price for each trade. Date, side, size, P&L and fees are optional.', 'No file? Add trades by hand in the journal instead.'],
  },
];

// Stock brokers, shown on the free report card (menus as of October 2026; they change).
export const STOCK_EXPORTS = [
  {
    name: 'Webull',
    steps: ['Open your order history (Orders) on the Webull website or desktop app.', 'Choose the date range and export it as a CSV. Stocks and options may come as separate files.'],
  },
  {
    name: 'Schwab',
    steps: ['On schwab.com, open Accounts and then History.', 'Pick the account and dates, then click Export to download a CSV.'],
  },
  {
    name: 'Robinhood',
    steps: ['On the Robinhood website, open Account, then Reports and statements, then Reports.', 'Request an account activity report (CSV) for your dates. It shows up there when it’s ready.'],
  },
];
